import { render } from "./WorkmanGroup.vue?vue&type=template&id=3ae03181"
import script from "./WorkmanGroup.vue?vue&type=script&lang=js"
export * from "./WorkmanGroup.vue?vue&type=script&lang=js"
script.render = render

export default script